module.exports = __webpack_public_path__ + "static/lifeChat-img1-24abfa2f3e5f7c1b297135321a8b49a4.jpg";